import { put, get, postFd } from "@utils/axios";

const Api = "settings";

export const getSettings = () => {
  return get(Api);
}

export const updateSettings = (payload) => {
  return postFd(Api, payload);
}